<template>
  <v-container class="mt-0 pt-0">
    <!-----------CREATING NEW CATEGORY FORM--------------------------------------->
    <v-form @submit.prevent="createCategory" ref="createForm" lazy-validation>
      <v-dialog v-model="dialogCreate" width="50%" persistent>
        <v-card>
          <v-card-title class="headline footer" primary-title>
            {{ dialogText }}
          </v-card-title>
          <br />
          <v-card-text>
            <v-flex xs12 sm6 offset-sm3 mt-3>
              <v-layout column>
                <v-flex>
                  <v-text-field label="Title" v-model="titleNew" type="text" :rules="[rules.required]">
                  </v-text-field>
                </v-flex>
                <v-flex>
                  <v-checkbox label="Can be selected in listings" v-model="forUse">
                  </v-checkbox>
                </v-flex>
              </v-layout>
            </v-flex>
          </v-card-text>
          <v-divider></v-divider>

          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn outlined color="error" @click="closeCreateDialog">
              Close
            </v-btn>
            <v-btn color="success" outlined @click="createCategory">
              Save
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-form>
    <!----------------------------------------------------------------------------->

    <!-----------MAIN CONTAINER---------------------------------------------------->
    <v-card v-if="!failed">
      <v-card-title class="footer basic--text headline py-2">
        <v-row>
          <v-col cols="3"> Category tree </v-col>

          <v-col>
            <v-btn @click="openCreateTopCategory" color="accent" outlined>
              NEW TOP CATEGORY
              <v-icon right>mdi-plus-circle</v-icon>
            </v-btn>
          </v-col>
        </v-row>
      </v-card-title>
      <!-----------SEARCH BAR------------------------------------------------------->
      <v-sheet class="px-2 pb-2 footer">
        <v-text-field v-model="search" label="Search Category" flat solo-inverted hide-details dense clearable
          clear-icon="mdi-close-circle-outline"></v-text-field>
      </v-sheet>

      <!----------------------------------------------------------------------------->
      <v-row class="pa-4" justify="space-between">
        <!-----------LEFT TAB (CATEGORY TREE)------------------------------------------>

        <v-col cols="3" class="px-0">
          <v-row>
            <v-col class="ml-1 pb-0">
              <v-tooltip right>
                <template v-slot:activator="{ on, attrs }">
                  <v-icon v-bind="attrs" v-on="on" @click="toggleTreeview" size="30">{{
                    expanded
                      ? "mdi-unfold-less-horizontal"
                      : "mdi-unfold-more-horizontal"
                  }}</v-icon>
                </template>
                <span>Expand/Collapse all</span>
              </v-tooltip>
            </v-col>
          </v-row>
          <v-row>
            <v-col>
              <v-treeview :active.sync="active" :items="items" return-object activatable color="accent" transition
                :search="search" :filter="filter" @update:active="setCategoryDetails" dense :open-all="expanded"
                ref="mytreeview" :expand-icon="'mdi-chevron-down'">
                <template slot="append" slot-scope="{ item }">
                  <v-btn class="ml-6" id="addBtn" @click="openCreateSubCategory(item)" fab color="accent" small>
                    <v-icon dark> mdi-plus </v-icon>
                  </v-btn>
                </template>
              </v-treeview>
            </v-col>
          </v-row>
        </v-col>
        <v-divider vertical></v-divider>
        <!-------------------------------------------------------------------------------------->

        <!-----------RIGHT TAB (CONFIGURATION)-------------------------------------------------->
        <v-col class="d-flex" cols="9">
          <v-scroll-y-transition mode="out-in">
            <!-----------SHOW THIS DIV IF CATEGORY CANNOT BE CONFIGURATED--------------------------->
            <div v-if="!selected" class="title footer--text text--lighten-1 font-weight-light"
              style="align-self: center">
              Select a category
            </div>
            <!-------------------------------------------------------------------------------------->
            <!-----------SHOW THIS DIV IF CATEGORY CAN BE CONFIGURATED------------------------------->
            <div v-else style="width: 100%">
              <div class="pt-6 mx-auto text-center" :key="active[0].id">
                <h3 class="headline mb-2 text-center basic--text">
                  {{ active[0].name }}
                </h3>
                <v-divider></v-divider>
              </div>
              <!-----------TABS---------------------------------------------------------------->
              <div>
                <v-tabs v-model="tab" background-color="transparent" color="primary" grow>
                  <v-tab v-for="tab in tabs" :key="tab.value">
                    {{ tab.text }}
                  </v-tab>
                </v-tabs>
                <!-----------TAB ITEMS--------------------------------------------------------->
                <v-tabs-items v-model="tab">
                  <v-tab-item v-for="tab in tabs" :key="tab.value">
                    <!-----------IF TAB IS CONFIGURATION---------------------------------------->
                    <v-card v-if="tab.value == 'edit_conf'" flat>
                      <v-alert class="my-4" text dense color="blue" icon="mdi-information-outline" border="left">
                        If your selected field type is "Select", then write down
                        select values dividing them by commas.
                      </v-alert>
                      <v-form @sumbit.prevent="pushConfig" ref="configForm" lazy-validation v-model="valid">
                        <v-layout v-for="(item, i) in fields" :key="i">
                          <v-sheet color="accent_light" class="mb-4 pt-4" width="100%">
                            <v-row align-content="center">
                              <v-col cols="2">
                                <v-text-field label="Title" v-model="item.name" type="text" :rules="[rules.required]"
                                  outlined dense>
                                </v-text-field>
                              </v-col>
                              <v-col cols="2">
                                <v-select label="Field type" v-model="item.fieldType" :items="fieldTypes"
                                  item-text="text" item-value="value" type="text" :rules="[rules.required]" outlined
                                  dense>
                                </v-select>
                              </v-col>
                              <!-------IF SELECTED INPUT TYPE IS SELECT, THEN SHOW ADDITIONAL INPUT FIELD FOR SELECT VALUES--->
                              <v-col cols="3" v-if="item.fieldType == 'select'">
                                <v-combobox multiple v-model="item.selectValues" label="Enter values for select" chips
                                  deletable-chips @keyup.tab="updateTags" @paste="updateTags" :delimiters="[',']"
                                  :rules="[rules.requiredMultiple]" dense small-chips outlined>
                                </v-combobox>
                              </v-col>
                              <!----------------------------------------------------------------------------------------------->

                              <v-col cols="2">
                                <v-select label="Purpose" v-model="item.purpose" :items="purposes" type="text"
                                  :rules="[rules.required]" outlined dense>
                                </v-select>
                              </v-col>
                              <v-col cols="2" v-if="item.purpose == 'Measurements'">
                                <v-text-field label="Representation" v-model="item.representation" type="text" outlined
                                  dense>
                                </v-text-field>
                              </v-col>
                              <v-col cols="2">
                                <v-checkbox v-model="item.required" label="Required" color="#127897" dense>
                                </v-checkbox>
                              </v-col>
                              <v-col cols="1" class="mt-1">
                                <v-icon class="ml-4" size="30" color="error" cursor="pointer"
                                  @click="removeField(i)">mdi-close-thick</v-icon>
                              </v-col>
                            </v-row>
                          </v-sheet>
                        </v-layout>

                        <v-row>
                          <v-col cols="4">
                            <v-btn color="success" @click="addField" outlined>
                              <v-icon left> mdi-plus-circle </v-icon>
                              Add field</v-btn>
                          </v-col>
                        </v-row>

                        <v-row v-if="imageSrc != ''">
                          <v-col cols="4">
                            <v-img width="300" :src="imageSrc"></v-img>
                          </v-col>
                        </v-row>

                        <v-divider class="my-2"></v-divider>

                        <h4 class="pt-4 basic--text">
                          Add instruction image <v-icon>mdi-arrow-down</v-icon>
                        </h4>
                        <v-row>
                          <v-col cols="6">
                            <template>
                              <v-file-input v-model="image" accept="image/png, image/jpeg, image/bmp"
                                placeholder="Pick an image" prepend-inner-icon="mdi-camera" prepend-icon=""
                                label="Instruction image" outlined dense></v-file-input>
                            </template>
                          </v-col>
                        </v-row>

                        <v-divider class="pt-4"></v-divider>
                        <v-row>
                          <v-col cols="4">
                            <v-btn color="success" @click="pushConfig" :disabled="!valid">
                              <v-icon left> mdi-import </v-icon>
                              Save configuration</v-btn>
                          </v-col>
                        </v-row>
                      </v-form>
                    </v-card>
                    <!--------------------------------------------------------------------------->

                    <!-----------IF TAB IS SPECIFICS---------------------------------------------->
                    <v-card v-else flat>
                      <br />
                      <br />
                      <h4 v-if="configSuccess" class="basic--text">
                        Specifics:
                      </h4>
                      <v-data-table v-if="configSuccess" :headers="headers" :items="fields" hide-default-footer
                        disable-pagination dense>
                        <template v-slot:[`item.required`]="{ item }">
                          <slot v-if="item.required">
                            <v-icon color="#66BB6A">mdi-check-circle-outline</v-icon>
                          </slot>
                          <slot v-else>
                            <v-icon color="#EF5350">mdi-close-circle-outline</v-icon>
                          </slot>
                        </template>
                        <template v-slot:[`item.fieldType`]="{ item }">
                          <slot v-if="item.fieldType == 'string'"> text </slot>
                          <slot v-else> {{ item.fieldType }} </slot>
                        </template>
                      </v-data-table>
                      <v-layout v-else>
                        <v-container fill-height fluid>
                          <v-row align="center" justify="center">
                            <h2>Sorry, something went wrong...</h2>
                          </v-row>
                          <v-row align="center" justify="center">
                            <v-img v-if="filename !== ''" :src="require(`@/assets/${filename}`)" max-width="200">
                            </v-img>
                          </v-row>
                        </v-container>
                      </v-layout>
                    </v-card>
                    <!-----------TAB ITEMS-------------------------------------------------------->
                  </v-tab-item>
                </v-tabs-items>
                <!----------------------------------------------------------------------------->
              </div>
              <!------------------------------------------------------------------------------->
            </div>
            <!------------------------------------------------------------------------------------->
          </v-scroll-y-transition>
        </v-col>
      </v-row>
    </v-card>
    <!----------------------------------------------------------------------------->

    <!-----------STATUS DIALOG----------------------------------------------------->
    <v-dialog v-model="statusDialog" width="unset">
      <status-info :responseMessage="responseMessage" :filename="filename" :pending="false" @close="closeStatusDialog">
      </status-info>
    </v-dialog>
    <!----------------------------------------------------------------------------->

    <!-----------------IF SERVER IS COMPLETELY DOWN--------------------------------->
    <status-info v-if="failed && filename !== ''" :responseMessage="responseMessage" :filename="filename"
      :pending="false" @close="reset">
    </status-info>
    <!------------------------------------------------------------------------------->

    <!-------------------RED SNACKBAR----------------------------------------------->
    <v-snackbar top v-model="snackbar" color="#FF3232" class="white--text">
      {{ snackbarText }}
      <template v-slot:action="{ attrs }">
        <v-btn color="white" text v-bind="attrs" @click="snackbar = false">
          Close
        </v-btn>
      </template>
    </v-snackbar>
    <!------------------------------------------------------------------------------->
  </v-container>
</template>

<script>
import StatusInfo from "../organisms/StatusInfo";

export default {
  name: "Categories",
  components: {
    StatusInfo,
  },
  data: () => ({
    selected: false,
    currentId: "",
    currentCategory: "",
    creatingNew: false,
    items: [],
    tab: "",
    active: [],
    forUse: false,
    titleNew: "",
    dialogCreate: false,
    fields: [],
    dialogText: "",
    headers: [
      { text: "Name", value: "name" },
      { text: "Type", value: "fieldType" },
      { text: "Required", value: "required" },
      { text: "Purpose", value: "purpose" },
    ],
    fieldTypes: [
      { text: "Select", value: "select" },
      { text: "Text", value: "string" },
      { text: "Numbers", value: "number" },
      { text: "Composition", value: "composition" },
    ],
    purposes: ["Measurements", "Size", "Composition", "Other"],
    tabs: [
      { value: "config", text: "Configuration" },
      { value: "edit_conf", text: "Edit configuration" },
    ],
    rules: {
      required: (value) => !!value || "Field is required.",
      requiredMultiple: (value) => value.length > 0 || "Field is required",
    },
    responseMessage: "",
    filename: "",
    failed: false,
    search: null,
    caseSensitive: false,
    configSuccess: true,
    statusDialog: false,
    image: "",
    imageSrc: "",
    snackbar: false,
    snackbarText: "",
    valid: false,
    expanded: false,
  }),
  computed: {
    filter() {
      return this.caseSensitive
        ? (item, search, textKey) => item[textKey].indexOf(search) > -1
        : undefined;
    },
  },
  watch: {
    imageSrc(val) {
      if (val === undefined || val === null) {
        this.imageSrc = "";
      }
    },
    forUse(val) {
      if (val == null) this.forUse = false;
    },
  },
  methods: {
    toggleTreeview() {
      this.expanded = !this.expanded;
      this.$refs.mytreeview.updateAll(this.expanded);
    },
    updateTags() { },
    closeStatusDialog() {
      this.statusDialog = false;
    },
    //sets category details when category is clicked
    setCategoryDetails() {
      this.getCategoryConfig();

      if (this.active[0] !== undefined) {
        //if forUse is true, then fetch config fields
        if (this.active[0].forUse) {
          this.selected = this.active[0].forUse;
          this.getCategoryConfig();
        }
        //else empty config fields
        else {
          this.fields = [];
          this.selected = false;
        }
      }
      //if forUse is false, do not fetch config fields
      else {
        this.selected = false;
      }
    },
    async getCategoryConfig() {
      this.image = [];
      this.imageSrc = "";
      this.fields = [];
      try {
        const response = await this.$store.dispatch(
          "getCategory",
          this.active[0].id
        );
        if (response.data.configurations) {
          // this.fields = response.data.configurations.configurations;
          console.log(this.fields);
          //add representation field to every config which purpose is measurements:
          this.fields = await this.addRepresentationFields(
            response.data.configurations.configurations
          );
          console.log("after", this.fields);

          if (response.data.configurations.photos != undefined) {
            this.imageSrc = response.data.configurations.photos[0];
          } else {
            this.imageSrc = "";
          }
        } else {
          this.fields = [];
        }
      } catch (error) {
        this.textColor = "red--text";
        this.pending = false;
        this.responseMessage = error.response.data;
        if (error.response) {
          this.showErrors(error.response.status, error.response.data);
        } else {
          // anything else
          this.filename = "feeling_blue.png";
          this.responseMessage =
            "SORRY... Couldn't get category config. Something went wrong.";
        }
      }
    },
    async addRepresentationFields(fields) {
      let result = [];
      for (const field of fields) {
        console.log(field);
        let obj = field;
        if (field["purpose"] == "Measurements") {
          if (!field["representation"]) {
            obj["representation"] = "";
          }
        }
        result.push(obj);
      }
      return result;
    },
    // getting categories from server
    fetchCategories() {
      this.$store
        .dispatch("getCategories")
        .then((response) => {
          this.items = response.data;
        })
        .catch((error) => {
          this.textColor = "red--text";
          this.pending = false;
          this.responseMessage = error.response.data;
          if (error.response) {
            this.showErrors(error.response.status, error.response.data);
          } else {
            // anything else
            this.filename = "feeling_blue.png";
            this.responseMessage =
              "SORRY... Couldn't get categories. Something went wrong.";
          }
        });
    },
    //adds new field in the category configuration form
    addField() {
      this.fields.push({
        name: "",
        fieldType: "",
        purpose: "",
        required: false,
      });
    },
    checkIfInputIsSelect() {
      for (let item of this.fields) {
        if (
          item.fieldType === "select" &&
          typeof item.selectValues === "string"
        ) {
          //make an array of selected values
          let selectValuesArr = [];
          selectValuesArr = item.selectValues.split(",");

          //item which should be written on the current item
          let source = {
            name: item.name,
            fieldType: item.fieldType,
            required: item.required,
            selectValues: selectValuesArr,
          };

          //overwrite object with the new item source
          Object.assign(item, source);
        }
      }
    },
    //pushes category configuration fields to backend
    pushConfig() {
      //check if input field type is SELECT and push it's values to an array
      this.checkIfInputIsSelect();
      let categoryName = this.active[0].name;

      let bodyFormData = new FormData();

      bodyFormData.append("data", JSON.stringify(this.fields));

      if (this.imageSrc != "") {
        bodyFormData.append("photos", this.imageSrc);
      }
      if (this.image) {
        bodyFormData.append("files", this.image);
      }

      // validation (check if all required fields are filled)
      if (this.$refs.configForm[0].validate()) {
        if (this.fields.length > 0) {
          let data = {
            id: this.active[0].id,
            data: bodyFormData,
          };
          this.$store
            .dispatch("putCategoryConf", data)
            .then(() => {
              this.filename = "high_five.svg";
              this.statusDialog = true;
              this.responseMessage =
                "Success! Configuration of " + categoryName + " updated!";
              this.tab = "config";
              this.setCategoryDetails();
              this.image = [];
            })
            .catch((error) => {
              this.image = [];
              this.textColor = "red--text";
              this.pending = false;
              this.responseMessage = error.response.data;
              if (error.response) {
                this.showErrors(error.response.status, error.response.data);
              } else {
                // anything else
                this.filename = "feeling_blue.png";
                this.responseMessage =
                  "SORRY... Couldn't save category config. Something went wrong.";
              }
            });
        } else {
          this.snackbarText = "At least one field should be added!";
          this.snackbar = true;
        }
      }
    },
    reset() {
      this.$router.go();
    },
    closeCreateDialog() {
      this.dialogCreate = false;
      this.$refs.createForm.reset();
    },
    //opens create dialog when clicked 'Add new top level category' button at the bottom
    openCreateTopCategory() {
      this.creatingNew = true;
      this.dialogText = "Create new top level category";
      this.dialogCreate = true;
    },
    //opens create dialog when clicked + button near category
    openCreateSubCategory(item) {
      this.dialogCreate = true;
      this.dialogText = "Create new sub-category for " + item.name;
      this.currentId = item.id;
      this.currentCategory = item.name;
    },
    //creates new category/sub-category
    createCategory() {
      if (this.$refs.createForm.validate()) {
        //check if we are creating top level category
        if (this.creatingNew) {
          this.postNewRootCategory();
        } else {
          this.postNewSubCategory();
        }
      }
    },
    postNewSubCategory() {
      //create child category
      let data = {
        id: this.currentId,
        data: {
          name: this.titleNew,
          forUse: this.forUse,
        },
      };
      this.$store
        .dispatch("postNewSubCategory", data)
        .then(() => {
          this.dialogCreate = false;
          this.creatingNew = false;
          this.filename = "high_five.svg";
          this.statusDialog = true;
          this.responseMessage =
            "Success! Sub-category " +
            this.titleNew +
            " created for category " +
            this.currentCategory;
          this.fetchCategories();
          this.$refs.createForm.reset();
        })
        .catch((error) => {
          this.textColor = "red--text";
          this.pending = false;
          this.responseMessage = error.response.data;
          if (error.response) {
            this.showErrors(error.response.status, error.response.data);
          } else {
            // anything else
            this.filename = "feeling_blue.png";
            this.responseMessage =
              "SORRY... Couldn't get category config. Something went wrong.";
          }
        });
    },
    postNewRootCategory() {
      //create whole new category
      this.$store
        .dispatch("postNewRootCategory", {
          name: this.titleNew,
          forUse: this.forUse,
        })
        .then(() => {
          this.dialogCreate = false;
          this.creatingNew = false;
          this.filename = "high_five.svg";
          this.statusDialog = true;
          this.responseMessage =
            "Success! Category " + this.titleNew + " created!";
          this.fetchCategories();
          this.$refs.createForm.reset();
        })
        .catch((error) => {
          switch (error.response.status) {
            case 400:
              this.responseMessage =
                "Sorry, something went wrong, please contact TECH team!";
              this.filename = "empty.svg";
              this.statusDialog = true;
              this.$refs.createForm.reset();
              break;
            case 401:
              //clear local storage, push to login
              localStorage.clear();
              this.$router.push("login");
              break;
            case 403:
              this.responseMessage =
                "Sorry, you are forbidden to do this action!";
              this.filename = "403_forbidden.svg";
              this.statusDialog = true;
              this.$refs.createForm.reset();
              break;
            case 500:
              this.responseMessage =
                "Internal server error, please contact TECH team!";
              this.filename = "server_down.svg";
              this.statusDialog = true;
              this.$refs.createForm.reset();
          }
        });
    },
    removeField(index) {
      this.fields.splice(index, 1);
    },
    showErrors(status, message) {
      // client received an error response (5xx, 4xx)
      this.responseMessage = message;
      switch (status) {
        case 400:
          this.filename = "empty.svg";
          break;
        case 401:
          //clear local storage, push to login
          localStorage.clear();
          this.$router.push("login");
          break;
        case 403:
          this.filename = "403_forbidden.svg";
          break;
        case 404:
          this.responseMessage = "Bad request. Please contact TECH team.";
          this.filename = "void.png";
          break;
        case 500:
          this.filename = "server_down.svg";
      }
    },
  },
  created() {
    this.fetchCategories();
  },
};
</script>

<style>
#addBtn:hover {
  transform: scale(1.15);
}
</style>
